import { KtData } from "../KtData";
import { simpleKtName } from "./simpleKtName";

const JS_EXPORT = "kotlin.js.JsExport";
const SERIALIZABLE = "kotlinx.serialization.Serializable";

function annotate(annotation: string, statement: string, data: KtData): string {
  data.currentFile.imports.add(annotation);
  return `@${simpleKtName(annotation)}\n${statement}`;
}

export function jsExport(statement: string, data: KtData): string {
  return annotate(JS_EXPORT, statement, data);
}

export function serializable(statement: string, data: KtData): string {
  return annotate(SERIALIZABLE, statement, data);
}
